import React, { useState, createContext, useContext } from 'react';
interface ScoreContextType {
  answers: Record<string, string>;
  setAnswer: (questionId: string, answerId: string) => void;
  answeredCount: number;
}
const ScoreContext = createContext<ScoreContextType | undefined>(undefined);
// DEMO_SEED: the mockup pre-answers the first Quick Check (option B) so the
// selected/saved state and sticky widget are visible for review.
// PRODUCTION: set this to false so a first-time visitor starts with zero
// answered. Real saved progress would be hydrated from storage instead.
const DEMO_SEED = true;
export function ScoreProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [answers, setAnswers] = useState<Record<string, string>>(DEMO_SEED ? {
    q1: 'b'
  } : {});
  const setAnswer = (questionId: string, answerId: string) => {
    setAnswers(prev => ({
      ...prev,
      [questionId]: answerId
    }));
  };
  const answeredCount = Object.keys(answers).length;
  return <ScoreContext.Provider value={{
    answers,
    setAnswer,
    answeredCount
  }} data-id="element-426">
      {children}
    </ScoreContext.Provider>;
}
export function useScore() {
  const context = useContext(ScoreContext);
  if (context === undefined) {
    throw new Error('useScore must be used within a ScoreProvider');
  }
  return context;
}